import { render } from "./ModalChooseConnectOption.vue?vue&type=template&id=a925a0a0&scoped=true"
import script from "./ModalChooseConnectOption.vue?vue&type=script&lang=js"
export * from "./ModalChooseConnectOption.vue?vue&type=script&lang=js"

import "./ModalChooseConnectOption.vue?vue&type=style&index=0&id=a925a0a0&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a925a0a0"]])

export default __exports__